import { IconBase, IconComponent } from './BaseIcon';

export const Design: IconComponent = (props) => (
  <IconBase {...props}>
    <circle cx="12.97" cy="12.55" r="2.5" />
    <path d="M29.21 5.91a2.88 2.88 0 0 0-2.05-.86H4.93a3 3 0 0 0-2.93 3v16a3 3 0 0 0 .85 2.11 2.88 2.88 0 0 0 2.09.89h22.21a3 3 0 0 0 2.93-3v-16a3 3 0 0 0-.87-2.14zM4.93 7.05h22.23a.9.9 0 0 1 .64.27 1 1 0 0 1 .3.73v14.66L20 14.57l-6.61 6.67L9.3 18.3 4 23.62V8.05a1 1 0 0 1 .93-1zM27.14 25H5.39l4.12-4.13 4.07 2.94 6.42-6.4L27.48 25a.87.87 0 0 1-.34 0z" />
  </IconBase>
);
